import { APP_BASE_HREF } from '@angular/common';
import { Component, Inject, Input, OnInit } from '@angular/core';
import { ResponseHandler } from '@app/_core/helper/ResponseHandler';
import { Utils } from '@app/_core/helper/Utils';
import { ManagerService } from '@app/_core/services/manager.service';
import { FilterDialogComponent } from '@app/pages/common/filter-dialog/filter-dialog.component';
import { BsModalRef, BsModalService, ModalOptions } from 'ngx-bootstrap/modal';
import { catchError, EMPTY, map } from 'rxjs';

import { InteractionDetailsComponent } from '../../interactions/interaction-details/interaction-details.component';
import { SecurityService } from '@app/_core/services/security.service';

@Component({
  selector: 'app-livestatuses-interactions',
  templateUrl: './livestatuses-interactions.component.html',
  styleUrls: ['./livestatuses-interactions.component.scss'],
})
export class LivestatusesInteractionsComponent implements OnInit {
  @Input() interactionId: any;
  interactionList: any = [];
  originalInteractionList: any = [];
  dataToDisplay: any = [];
  filteredData: any = [];

  modalRef?: BsModalRef;
  //isAsc: boolean = false;
  selectedFilterByField: any = '';
  filterVal: any = '';
  isAudit: boolean = false;

  cols: any = [
    {
      name: 'InteractionID',
      label: 'InteractionID',
      showFilter: false,
      type: 'numeric',
    },
    { name: 'Type', label: 'Type', showFilter: true },
    { name: 'Queue', label: 'Queue', showFilter: true },
    { name: 'User', label: 'User', showFilter: false, format: 'name' },
    { name: 'Disposition', label: 'Disposition', showFilter: true },
    { name: 'DispositionType', label: 'Disposition Type', showFilter: true },
    {
      name: 'HandlingTime',
      label: 'Handling Time',
      showFilter: false,
      type: 'numeric',
      format: 'duration',
    },
    {
      name: 'Recordings',
      label: 'Recordings',
      showFilter: false,
      sortable: false,
      format: 'html',
    },
    { name: 'Date', label: 'Date', type: 'date', showFilter: false },
  ];

  constructor(
    private utils: Utils,
    private managerService: ManagerService,
    private modalService: BsModalService,
    private securityService: SecurityService,
    @Inject(APP_BASE_HREF) public baseHref: string
  ) { }

  ngOnInit(): void {
    console.log('calling loadInteractions');
    this.loadInteractions();
  }

  loadInteractions() {
    this.managerService
      .GetAgentInteractions(this.interactionId)
      .pipe(
        map((data: any) => {
          const isValid = ResponseHandler.processResponse(data, 'GetLiveStatuses');
          if (isValid) {
            this.interactionList = data.Response.Data.Data;

            let interactiondata = [],
            x,
            y,
            row,
            recordings,
            handlingTime;
          for (x = 0, y = this.interactionList.length; x < y; x++) {
            row = this.interactionList[x];
            recordings = '<div align="center">';
            recordings += row.VideoRecording ? '<div class="iconButton iconVideo hideLabel" title="Video"></div>' : '';
            recordings += row.Recording ? '<div class="iconButton iconAudio hideLabel" title="Audio"></div>' : '';
            recordings += row.Transcript
              ? '<div class="iconButton iconTranscript hideLabel" title="Transcript"></div>'
              : '';
            recordings += '</div>';
            //row.HandlingTime = this.formatDateTime((row.HandlingTime < 0) ? 0 : row.HandlingTime);
            handlingTime = this.utils.formatDuration(row.HandlingTime, 's', false, true, false);
            row.HandlingTime = handlingTime;
            row.Recordings = recordings;
            interactiondata.push(row);
          }
          this.originalInteractionList = interactiondata;
            this.filteredData = this.interactionList;
            this.dataToDisplay = this.interactionList;
            // this.dataToDisplay.forEach(element => {
            //   if (element.HandlingTime <= 0) {
            //     element.HandlingTime = '';
            //   } else {
            //     element.HandlingTime = this.utils.formatDuration(element.HandlingTime, 'sec', false, true, false);
            //   }

            //   let recording = '<div align="center">';
            //   recording += element.VideoRecording
            //     ? '<div class="iconButton iconVideo hideLabel" title="Video"><div>Video</div></div>'
            //     : '';
            //   recording += element.Recording ? '<div class="iconButton iconAudio hideLabel" title="Audio"><div></div></div>' : '';
            //   recording += element.Transcript
            //     ? '<div class="iconButton iconTranscript hideLabel" title="Transcript"><div>Transcript</div></div>'
            //     : '';
            //   recording += '</div>';
            //   return recording;
            // })
          }
        }),
        catchError(error => {
          console.log(error);
          return EMPTY;
        })
      )
      .subscribe();
  }

  toggleCustomColumnFilter(colName: string) {
    for (const col of this.cols) {
      if (col.name == colName) {
        if (col.filterVals) {
        } else {
          const unique = [...new Set(this.filteredData.map((item: any) => item[colName]))];
          const filterData: any = [];
          for (const val of unique) {
            filterData.push({ name: val, checked: false });
          }
          col.filterVals = filterData;
        }
      } else {
      }
    }
    this.showColumnFilterModal(colName);
  }

  showColumnFilterModal(colName: string) {
    const initialState = {
      cols: this.cols,
      colName: colName,
    };

    const config: ModalOptions = { class: 'task-menu', backdrop: 'static', initialState };

    this.modalRef = this.modalService.show(FilterDialogComponent, config);

    this.modalRef.content.event.subscribe((result: any) => {
      this.cols = result.data;
      this.dataToDisplay = this.applyColumnFilters(this.filteredData);
    });
  }
  formatDateTime(dt: any, inclSeconds: any = 0, inclWeekDay: any = 0) {
    return (
      (inclWeekDay ? this.getDayOfWeek(dt) + ' ' : '') + this.formatDate(dt) + ' ' + this.formatTime(dt, inclSeconds)
    );
  }

  getDayOfWeek(dt: any) {
    const days = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
    return days[dt.getDay()];
  }
  formatTime(dt: any, inclSeconds: any) {
    if (isNaN(dt)) return '0:00';

    let isPM = false,
      hour: any = new Date(dt).getHours(),
      min: any = new Date(dt).getMinutes(),
      seconds: any = new Date(dt).getSeconds();
    if (hour > 11) {
      isPM = true;
      if (hour > 12) hour = hour - 12;
    } else if (hour == 0) hour = 12;
    if (min < 10) min = '0' + min;
    if (seconds < 10) seconds = '0' + seconds;
    return hour + ':' + min + (inclSeconds ? ':' + seconds : '') + (isPM ? ' PM' : ' AM');
  }

  formatDate(dt: any) {
    return this.utils.formatDate(dt);
  }
  /*column level filter*/
  applyColumnFilters(list: any) {
    //apply column filter here and assign to dataTodisplay
    let records = list;
    for (const colData of this.cols) {
      const filterVals: any = [];
      if (colData.filterVals && colData.filterVals.length > 0) {
        for (const val of colData.filterVals) {
          if (val.checked) {
            filterVals.push(val.name);
          }
        }
        //filterVals
        records = this.filterBySelectedFieldValues(records, colData.name, filterVals);
      }
    }
    return records;
  }

  filterBySelectedFieldValues(set: any, properties: string, searchText: []) {
    if (searchText.length > 0) {
      return set.filter((entry: any) => {
        for (const search of searchText) {
          if (entry[properties].toString() == search) {
            return entry;
          }
        }
      });
    } else {
      return set;
    }
  }
  sortByColumn(colName: string) {
    this.dataToDisplay = this.utils.sortByField(colName, this.cols, this.dataToDisplay);
  }

  onRowSelect(event: any) {
    // console.log(event.data.interactionID);

    // const initialState = {
    //   interactionId: event.data.InteractionID,
    // };
    // const config: ModalOptions = {
    //   backdrop: 'static',
    //   class: 'interactionDetails-menu',
    //   initialState,
    // };
    // this.modalRef = this.modalService.show(InteractionDetailsComponent, config);
    this.isAudit = this.securityService.validateGrant('AuditAgents');
    // console.log(event.data.ID);

    if (this.isAudit == true) {
      const initialState = {
        interactionId: event.data.InteractionID,
      };
      const config: ModalOptions = {
        backdrop: 'static',
        class: 'interactionDetails-Auditmenu',
        initialState,
      };
      this.modalRef = this.modalService.show(InteractionDetailsComponent, config);
    } else {
      const initialState = {
        interactionId: event.data.InteractionID,
      };
      const config: ModalOptions = {
        backdrop: 'static',
        class: 'interactionDetails-menu',
        initialState,
      };
      this.modalRef = this.modalService.show(InteractionDetailsComponent, config);
    }
  }
}
